const NotAccessPage = () => {
  return (
    <p>
      You have no access assigned to your role. Please reach out your manager
    </p>
  )
}
export default NotAccessPage
